import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Home.css";

import img1 from "../photos/registon.webp";
import img2 from "../photos/bibihonim1.webp";
import img3 from "../photos/guri_amir.webp";
import img4 from "../photos/samarqand1.webp";
import img5 from "../photos/samarqand_city1.webp";
import img6 from "../photos/samarqand_city2.webp";
import img7 from "../photos/food4.webp";

const IMAGES = [img1, img2, img3, img4, img5, img6, img7];

export default function Home() {
    const { t } = useTranslation();

    const SLIDES = t("home.slides", { returnObjects: true });

    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setFade(false);
            setTimeout(() => {
                setIndex((prev) => (prev + 1) % IMAGES.length);
                setFade(true);
            }, 400);
        }, 7000);

        return () => clearInterval(interval);
    }, []);

    return (
        <main className="home-hero">

            {/* SEO */}
            <Helmet>
                <title>{t("home.seo_title")}</title>
                <meta name="description" content={t("home.seo_desc")} />
            </Helmet>

            {/* BACKGROUND */}
            <div
                className={`home-bg ${fade ? "fade-in" : "fade-out"}`}
                style={{ backgroundImage: `url(${IMAGES[index]})` }}
            />

            <div className="home-overlay" />

            {/* CONTENT */}
            <div className="home-content">

                <h1 className="home-title">
                    {t("home.main_title")}
                </h1>

                <h2 className="home-subtitle">
                    {SLIDES?.[index % SLIDES.length]?.title}
                </h2>

                <p className="home-text">
                    {SLIDES?.[index % SLIDES.length]?.subtitle}
                </p>

                <div className="home-actions">
                    <Link to="/contact" className="home-btn primary">
                        {t("home.get_in_touch")}
                    </Link>

                    <Link to="/about" className="home-btn outline">
                        {t("home.learn_more")}
                    </Link>
                </div>

            </div>
        </main>
    );
}